/**
 * Upper first character
 * @example
 * ```js
 * upperFirst('test title'); // Test title
 * ```
 * @param text
 */
export function upperFirst(text: string | null | undefined): string {
    const text$ = text || '';

    if (typeof text$ === 'string' && text$) {
        return `${text$[0]?.toUpperCase()}${text$.substr(1)}`;
    }

    return text$;
}
